import TreeContainer from "../../../components/tree/TreeContainer";
import React from "react";

export default function AlberoStrutturaTipiImpExpView({
                                                          treeData,
                                                          tipoSel,
                                                          vociClickDestro
                                                      }) {

    return (
        <div className={'ns-overflow-auto ns-overflow-tree'}>
            <TreeContainer
                data={treeData}
                idSelected={tipoSel && tipoSel.id}
                onClickItem={(item) => {
                }}
                getLabel={(elemento) => elemento.label}
                getFigli={(elemento) => elemento.nodes}
                initEsploso={true}
                icona={(el) => <i className={el.icona_classe}/>}
                vociClickDestro={vociClickDestro}
            />
        </div>
    );
}